import Vue from 'vue';
import AreaBind from './areaModal.vue'

let DialogConstructor = Vue.extend(AreaBind) // 构造函数
let instance // 实例对象

const Area_bind_Dialog = (options = {}) => {
  instance = new DialogConstructor({
    data: options
  })
  
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  return instance.vm
}

export default Area_bind_Dialog


// WEBPACK FOOTER //
// ./src/components/AreaBind/index.js